const DATA_URL = 'https://a3pl499ihc.execute-api.ap-southeast-2.amazonaws.com/adventapi/prod/';

export const getUserData = (userId) => {
    return fetch(DATA_URL + 'getUserStats?id=' + userId)
        .then(data => data.json())
};

export const getResultsData = () => {
    return fetch(DATA_URL + 'getResults')
        .then(data => data.json())
};

export const submitSignUp = (userData) => {
    return fetch(DATA_URL + 'submitSignUp', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    });
};

export const checkIfSignedUp = async (userId) => {
    try {
        const response = await fetch(DATA_URL + 'getUserTeam?id=' + userId);
        const data = await response.json();
        
        if (Array.isArray(data) && data.length > 0) {
            return true;
        }
        
        if (data && typeof data === 'object' && data.message) {
            return false;
        }
        
        return false;
    } catch (error) {
        return false;
    }
};